import React from 'react';
import * as S from './styled';
import Icon from '../Icon';

const getText = type =>
  ({
    BoletoBancario:
      'Não foi possível gerar o boleto, tente novamente mais tarde.',
    DebitoEmConta: 'Dados da conta ou agência inválidos',
    CartaoCredito:
      'Pagamento não autorizado. Informe os dados de outro cartão para concluir a compra',
  }[type] ??
  'Ops! Nossos serviços estão temporariamente indisponíveis. Tente novamente mais tarde.');

const PaymentErrorModal = ({ onReject, type }) => (
  <S.StyledModal onReject={onReject}>
    <S.IconContainer>
      <Icon icon="atencao-m" />
    </S.IconContainer>
    <S.Text>{getText(type)}</S.Text>
  </S.StyledModal>
);

export default PaymentErrorModal;
